import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import DateFnsUtils from "@date-io/date-fns";
import { subDays } from "date-fns";
import enLocale from "date-fns/locale/en-US";
import ruLocale from "date-fns/locale/ru";

import { LANG }                       from "../../core/constants";

import RadioGroup                     from "./material-ui/RadioGroup";
import NumberField                    from "./material-ui/NumberField";

export default function DateTimeRange({ state, handleChange, classes, lang }) {
  const { t } = useTranslation();

  return (<>
    <RadioGroup
      style={{ display: "flex", marginLeft: "-16px" }}
      labels={['absolute','relative'].reduce((a,k) => {a[k]=t('datasets.'+ k +'_date'); return a}, {})}
      value={state.date_type || "absolute"}
      onChange={event => handleChange("date_type", event.target.value)}
    />
    <FormGroup className={classes.editLoadFromDCParamsRow}>
      {(state.date_type || "absolute") == "absolute" ? (<>
        <MuiPickersUtilsProvider
          utils={DateFnsUtils}
          locale={lang === LANG.RU ? ruLocale : enLocale}
        >
          <KeyboardDateTimePicker
            inputVariant="outlined"
            id="startDatePicker"
            ampm={false}
            disableFuture={true}
            minutesStep={5}
            className={classes.dateTextField}
            style={{ margin: 0, marginRight: 10 }}
            size="small"
            margin="normal"
            label={t("datasets.start_date")}
            okLabel={t("common.ok")}
            cancelLabel={t("common.cancel")}
            format="yyyy-MM-dd HH:mm"
            value={state?.startDate || subDays(new Date(), 1)}
            onChange={(date) =>
                handleChange("startDate", date)
            }
          />
        </MuiPickersUtilsProvider>
        <MuiPickersUtilsProvider
          utils={DateFnsUtils}
          locale={lang === LANG.RU ? ruLocale : enLocale}
        >
          <KeyboardDateTimePicker
            inputVariant="outlined"
            id="endDatePicker"
            ampm={false}
            className={classes.dateTextField}
            disableFuture={true}
            style={{ margin: 0 }}
            minutesStep={5}
            size="small"
            margin="normal"
            label={t("datasets.end_date")}
            okLabel={t("common.ok")}
            cancelLabel={t("common.cancel")}
            format="yyyy-MM-dd HH:mm"
            value={state?.endDate || new Date()}
            onChange={(date) =>
                handleChange("endDate", date)
            }
          />
        </MuiPickersUtilsProvider>
      </>) : state.date_type == "relative" ? (<>
        <NumberField
          id="quantity"
          label={t("datasets.amount")}
          className={classes.dateTextField}
          style={{ marginRight: 10 }}
          value={state?.quantity || ''}
          inputProps={{min: 1}}
          onChange={event => handleChange("quantity", event.target.value)}
        />
        <FormControl className={classes.dateTextField} size="small" variant='outlined'>
          <InputLabel id={`${t("datasets.period")}_label`}>{t("datasets.period")}</InputLabel>
          <Select
            label={t("datasets.period")}
            labelId="datasets_period_label"
            id="period"
            variant="outlined"
            value={state?.period || ""}
            onChange={event => {
              handleChange("period", event.target.value);
            }}
          >
            {["day", "week", "month", "year"].map(
              (item, idx) => <MenuItem style={{ fontSize: "13px" }} key={`${item}_${Math.random()}`}
                value={item}>{t('datasets.period_'+ item)}</MenuItem>)}
          </Select>
        </FormControl>
      </>) : null}
    </FormGroup>
  </>);
}

export function appendDateTimeParams(query, state) {
    const {
      date_type,
      startDate,
      endDate,
      quantity,
      period,
    } = state;

    query.append("date_type", date_type);
    if (date_type === "absolute") {
      query.append("startDate", new Date(startDate).toISOString());
      query.append("endDate", new Date(endDate).toISOString());
    } else if (date_type === "relative") {
      query.append("quantity", quantity);
      query.append("period", period);
    }
}

